module.exports = __webpack_public_path__ + "static/media/attachment.8a30d808.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/attachment.svg
// module id = 2376
// module chunks = 7